import { useEffect } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";

const initialFValues = {
  name: "",
  dc_number: "",
  street_address: "",
  city: "",
  province: "",
  postal_code: "",
};

export default function SunCustomersForm(props) {
  const { index, sunCustomer, setOpen, actionCall, isEdit } = props;

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false);

  const validateForm = () => {
    const newErrors = {};

    if (!values.name.trim()) {
      newErrors.name = "Location name is required";
    }

    if (!values.dc_number.trim()) {
      newErrors.dc_number = "DC number is required";
    }

    if (!values.street_address.trim()) {
      newErrors.street_address = "Street address is required";
    }

    if (!values.city.trim()) {
      newErrors.city = "City is required";
    }

    if (!values.province.trim()) {
      newErrors.province = "Province is required";
    }

    if (!values.postal_code.trim()) {
      newErrors.postal_code = "Postal code is required";
    } else if (!/^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i.test(values.postal_code)) {
      newErrors.postal_code = "Valid postal code required (e.g., M8Z 2G9)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (isEdit) {
        actionCall(sunCustomer, values, index);
      } else {
        actionCall(values);
      }
    }
  };

  useEffect(() => {
    if (isEdit && sunCustomer) {
      setValues({
        name: sunCustomer.name || "",
        dc_number: sunCustomer.dc_number || "",
        street_address: sunCustomer.street_address || "",
        city: sunCustomer.city || "",
        province: sunCustomer.province || "",
        postal_code: sunCustomer.postal_code || "",
        quickbooks_id: sunCustomer.quickbooks_id || "",
      });
    }
  }, [sunCustomer, setValues, isEdit]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit && sunCustomer
                ? `Edit ${sunCustomer.name}`
                : "Add New SUN Customer"}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div className="mt-2">
            <Input
              label="Location Name *"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              type="text"
              error={errors.name}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="DC Number *"
              name="dc_number"
              onChange={handleInputChange}
              value={values.dc_number}
              labelOn={true}
              type="text"
              error={errors.dc_number}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Street Address *"
              name="street_address"
              onChange={handleInputChange}
              value={values.street_address}
              labelOn={true}
              type="text"
              error={errors.street_address}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="City *"
              name="city"
              onChange={handleInputChange}
              value={values.city}
              labelOn={true}
              type="text"
              error={errors.city}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Province *"
              name="province"
              onChange={handleInputChange}
              value={values.province}
              labelOn={true}
              type="text"
              placeholder="e.g., ON"
              error={errors.province}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Postal Code *"
              name="postal_code"
              onChange={handleInputChange}
              value={values.postal_code}
              labelOn={true}
              type="text"
              placeholder="e.g., M8Z 2G9"
              error={errors.postal_code}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="mt-2">
            <Input
              label="Quickbooks Id"
              name="quickbooks_id"
              onChange={handleInputChange}
              value={values.quickbooks_id}
              labelOn={true}
              type="text"
              disabled={true}
              error={errors.quickbooks_id}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={handleSubmit}
        >
          {isEdit ? "Save" : "Create"}
        </button>
      </div>
    </div>
  );
}

